import React from 'react';
import { FieldValues } from 'react-hook-form';
//
import { FormInputProps } from '../../componets/form/formInterfaces';
import { ImperativeHandleAccessedByParentComponent } from '../../componets/interfaces/formProps';
import FormComplete from '../../componets/form/formComplete';
import * as ImplEnum from '../../communs/enums/generic-enum';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const enumInstances = {
    urgencyOptionsInstance: new ImplEnum.GenericEnum(ImplEnum.urgencyOptions),
    taskSituationOptionsInstance: new ImplEnum.GenericEnum(
        ImplEnum.taskSituationOptions,
    ),
};

const urgencyOptions = enumInstances.urgencyOptionsInstance.optionsList();

interface IFormInput extends FieldValues {
    description: string;
}

const Form: React.FC<{ settings: any }> = props => {
    const { settings } = props;
    const params = useParams<'id' | any>();
    const { user } = useAuth();

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentComponent<IFormInput>>(
            null,
        );

    const inputsForm = React.useMemo<FormInputProps<IFormInput>[]>(
        () => [
            {
                typeInput: 'text',
                name: 'task',
                control: null,
                label: 'Descrição da tarefa',
                loadingAutocomplete: false,
                md: 6,
                xs: 12,
                rules: {
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo Descrição é obrigatório',
                    },
                ],
            },
            {
                typeInput: 'autocomplete',
                name: 'urgency',
                control: null,
                label: 'Urgência',
                loadingAutocomplete: false,
                setValue: null,
                options: urgencyOptions,
                md: 3,
                xs: 12,
                rules: {
                    validate: (value: any) => {
                        if (!value?.id) {
                            return 'O campo é obrigatório';
                        }
                    },
                },
                dto: data => {
                    data.urgency = data.urgency.id;
                    return data;
                },
                setData: data => {
                    return enumInstances.urgencyOptionsInstance.getObject(
                        data.urgency,
                    );
                },
            },
            {
                typeInput: 'autocomplete',
                name: 'customer',
                control: null,
                label: 'Cliente',
                setValue: null,
                md: 3,
                xs: 12,
                rules: {
                    required: false,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo Cliente é obrigatório',
                    },
                ],
                query: (value: string) => `customer?name=${value}`,
                activeDebounce: true,
            },
            {
                typeInput: 'autocomplete',
                name: 'legalProcess',
                control: null,
                label: 'Processo',
                setValue: null,
                md: 3,
                xs: 12,
                rules: {
                    required: false,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo Processo é obrigatório',
                    },
                ],
                query: (value: string) =>
                    `legal-process?legalProcess.processNumber.ilike=${value}`,
                activeDebounce: true,
            },
            {
                typeInput: 'autocomplete',
                name: 'user',
                control: null,
                label: 'Advogado',
                setValue: null,
                md: 3,
                xs: 12,
                rules: {
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo Advogado(a) é obrigatório',
                    },
                ],
                query: (value: string) => `users?name=${value}`,
                activeDebounce: true,
            },
            {
                typeInput: 'date',
                name: 'taskDeadLine',
                control: null,
                label: 'Prazo',
                setValue: null,
                md: 3,
                xs: 12,
                placeholder: 'dd/mm/aaaa hh:mm',
                rules: {
                    validate: (value: any) => {
                        if (value && String(value) === 'Invalid Date') {
                            return 'A data está em um formato inválido';
                        }
                    },
                },
            },
            {
                typeInput: 'autocomplete',
                name: 'status',
                control: null,
                label: 'Status',
                loadingAutocomplete: false,
                setValue: null,
                options:
                    enumInstances.taskSituationOptionsInstance.optionsList(),
                md: 3,
                xs: 12,
                rules: {
                    validate: (value: any) => {
                        if (!value?.id) {
                            return 'O campo é obrigatório';
                        }
                    },
                },
                dto: data => {
                    data.status = data.status.id;
                    return data;
                },
                setData: data => {
                    return enumInstances.taskSituationOptionsInstance.getObject(
                        data.status,
                    );
                },
            },
        ],
        [],
    );

    const defaultValues = React.useMemo<any>(() => {
        return {
            user: {
                id: user.sub,
                description: user.name,
            },
            generateInstallments: !params?.id,
        };
    }, [user, params]);

    return (
        <FormComplete
            defaultValues={defaultValues}
            inputsForm={inputsForm}
            ref={refForm}
            settings={settings}
        />
    );
};

export default Form;
